import Control from "./Control.js";

export default class PlayerControl extends Control {
	constructor(callback) {
		super(callback);
	}

	init() {
		jQuery(window).on("keydown", this.onKeyDown.bind(this));
		jQuery(window).on("keyup", this.onKeyUp.bind(this));
		this.startCheck()
	}

	onKeyDown(e) {
		if (!this.enabled) {
			return;
		}

		//console.log(e.keyCode)
		if ((e.keyCode === Control.UP) || (e.keyCode === Control.UP_ALT)) {
			this.n = -1;
		}
		if ((e.keyCode === Control.RIGHT) || (e.keyCode === Control.RIGHT_ALT)) {
			this.e = 1;
		}
		if ((e.keyCode === Control.LEFT) || (e.keyCode === Control.LEFT_ALT)) {
			this.w = -1
		}
		if ((e.keyCode === Control.DOWN) || (e.keyCode === Control.DOWN_ALT)) {
			this.s = 1;
		}

		if ((e.keyCode === Control.FIRE)  || (e.keyCode === Control.FIRE_ALT)){
			this.fired = true;
		}
	}

	onKeyUp(e) {
		if (!this.enabled) {
			return;
		}

		if ((e.keyCode === Control.UP) || (e.keyCode === Control.UP_ALT)) {
			this.n = 0;
		}
		if ((e.keyCode === Control.RIGHT)|| (e.keyCode === Control.RIGHT_ALT)) {
			this.e = 0
		}
		if ((e.keyCode === Control.LEFT)  || (e.keyCode === Control.LEFT_ALT)) {
			
			this.w = 0;
		}
		if ((e.keyCode === Control.DOWN) || (e.keyCode === Control.DOWN_ALT)) {
			this.s = 0;
		}
	}


}